export interface ITravelSumary {
  duration: number,
  length: number,
  baseDuration: number
}
